import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { useDispatch } from 'react-redux'
import { appAllGetFacilityBooking } from '../../store/facilitybooking'
import { facilityBookingExportColumns } from '../../config/exportColumns/facilityBookingExportColumns'
import { useState } from 'react'

function FacilityBooking() {
	const dispatch = useDispatch()

	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Facility Booking</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appAllGetFacilityBooking({
										...params,
										...exportFilters,
										limit: 10000,
										sanstha: sansthaId || permissionOfSanstha,
										loading: false,
									}),
								)
							}
							columns={facilityBookingExportColumns}
							fileName="Facility_Bookings"
							sheetName="Facility Booking List"
							buttonText="Export Bookings"
						/>
					</div>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default FacilityBooking
